import { fg } from '@atlassian/jira-feature-gating';

const jiraChildIssuesPaginationRelayProvider = {
	get(): boolean {
		return fg('jira_child_work_items_pagination');
	},
};

export default jiraChildIssuesPaginationRelayProvider;
